/**
 * Date-extensions locale Welsh [cy]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('cy', {
    monthNames: ['Ionawr','Chwefror','Mawrth','Ebrill','Mai','Mehefin','Gorffennaf','Awst','Medi','Hydref','Tachwedd','Rhagfyr'],
    monthShortNames: ['Ion','Chwe','Maw','Ebr','Mai','Meh','Gor','Aws','Med','Hyd','Tach','Rhag'],
    dayNames: ['Dydd Sul','Dydd Llun','Dydd Mawrth','Dydd Mercher','Dydd Iau','Dydd Gwener','Dydd Sadwrn'],
    dayShortNames: ['Sul','Llun','Maw','Mer','Iau','Gwe','Sad']
});
